var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "bg-white md__card--holder clearfix" }, [
        _c("div", [
          _c("span", { staticClass: "d-flex chat-header-title yellow-class" }, [
            _c("span", { staticClass: "header-title" }, [
              _vm._v("Approval Request "),
              _c("span", { staticClass: "bracket" }, [_vm._v(" { ")]),
            ]),
          ]),
          _c("div", { staticClass: "card-header" }, [
            _c("p", [
              _vm._v(
                "\n          Invite your client to approve this project\n        "
              ),
            ]),
          ]),
        ]),
        _vm.currentProject
          ? _c("div", { staticClass: "payment-block" }, [
              _c(
                "div",
                { staticClass: "card card-body" },
                [
                  _c("UserPicker", {
                    attrs: { multi: false, role: "APPROVER" },
                    model: {
                      value: _vm.userInvite,
                      callback: function ($$v) {
                        _vm.userInvite = $$v
                      },
                      expression: "userInvite",
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success mt-4",
                      on: { click: _vm._requestApproverClicked },
                    },
                    [
                      _c("span", { staticClass: "icon-sml" }, [
                        _c("i", { staticClass: "fas fa-pay" }),
                        _vm._v("\n            Request Now\n          "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }